import React, { useState, useEffect, useRef } from 'react';
import './IAmHuman.css';

const Think5WhysIAmHuman = ({ setIamhuman }) => {
  const canvasRef = useRef(null);
  const [squares, setSquares] = useState([]);
  const [sequence, setSequence] = useState([]); // Random sequence
  const [clickedSequence, setClickedSequence] = useState([]);
  const [message, setMessage] = useState('');
  const colors = ['red', 'green', 'blue', 'orange', 'purple', 'amber']; // Colors for squares
  const answerNumbers = ['1', '2', '3', '4', '5', '6'];

  useEffect(() => {
    generateGridSquares();
  }, []);

  const generateGridSquares = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const newSquares = [];
    
    const squareSize = 75; 
    const margin = 5; 
    const startX = 5; 
    const startY = 5;
    const circleRadius = 30; // Radius for the circles

    // Generate a random sequence of numbers from 1 to 6
    const numbers = ['1', '2', '3', '4', '5', '6'];
    const shuffledNumbers = numbers.sort(() => Math.random() - 0.5);

    setSequence(shuffledNumbers);

    canvas.width = 3 * (squareSize + margin) + margin; // Adjust canvas width
    canvas.height = 2 * (squareSize + margin) + margin; // Adjust canvas height

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Define colors for the squares
    const colors = ['red', 'green', 'blue', 'orange', 'purple', 'amber'];

    // Generate a 3x2 grid
    for (let row = 0; row < 2; row++) {
      for (let col = 0; col < 3; col++) {
        const x = startX + col * (squareSize + margin);
        const y = startY + row * (squareSize + margin);
        const number = shuffledNumbers[row * 3 + col]; // Random number

        // Draw the square
        ctx.fillStyle = 'lightgray'; // Color for the square
        ctx.fillRect(x, y, squareSize, squareSize);

        // Draw the circle
        ctx.beginPath();
        ctx.arc(x + squareSize / 2, y + squareSize / 2, circleRadius, 0, Math.PI * 2); // Draw circle
        ctx.fillStyle = colors[row * 3 + col]; // Circle color
        ctx.fill();
        ctx.lineWidth = 3;
        ctx.strokeStyle = 'black'; // Circle border color
        ctx.stroke();

        // Add the number to the circle
        ctx.fillStyle = 'white'; // Text color
        ctx.font = '24px Arial';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(number, x + squareSize / 2, y + squareSize / 2);

        // Store square details for tracking clicks
        newSquares.push({ x, y, size: squareSize, text: number });
      }
    }
    setSquares(newSquares);
  };

  const getMousePos = (canvas, evt) => {
    const rect = canvas.getBoundingClientRect();
    return {
      x: evt.clientX - rect.left,
      y: evt.clientY - rect.top
    };
  };

  const debounce = (func, delay) => {
    let timerId;
    return (...args) => {
      if (timerId) clearTimeout(timerId);
      timerId = setTimeout(() => func(...args), delay);
    };
  };

  const handleCanvasClick = debounce((event) => {
    const canvas = canvasRef.current;
    const mousePos = getMousePos(canvas, event);

    squares.forEach((square) => {
      if (
        mousePos.x >= square.x &&
        mousePos.x <= square.x + square.size &&
        mousePos.y >= square.y &&
        mousePos.y <= square.y + square.size
      ) {
        if (!clickedSequence.includes(square.text)) {
          // console.log('Clicked Square:', square.text); // Debug: Show clicked square
          setClickedSequence((prevSequence) => [...prevSequence, square.text]);
        }
      }
    });
  }, 100);

  
  const handleRetry = () => {
    setClickedSequence([]);
    setMessage('');
    generateGridSquares();
  };

  useEffect(() => {
    if (clickedSequence.length === answerNumbers.length) {
      if (JSON.stringify(clickedSequence) === JSON.stringify(answerNumbers)) {
        setMessage('You are human!');
        setIamhuman(true);
      } else {
        setMessage('Sequence incorrect. Try again.');
        setIamhuman(false);
        setClickedSequence([]);
      }
    }
  }, [clickedSequence, answerNumbers, setIamhuman]);

  return (
    <div className='flex flex-col items-center'>
      <div className='border border-gray-500 p-4'>
        <canvas
          ref={canvasRef}
          onClick={handleCanvasClick}
          className="responsive-canvas"
        ></canvas>
      </div>
      {clickedSequence.length > 0 && (
        <div>
          <p className='text-white'>Clicked Sequence: {clickedSequence.join(', ')}</p>
        </div>
      )}
     <div className='mt-2'>
        <p className={`text-m ${message === 'You are human!' ? 'text-yellow-200' : 'text-red-400'} text-white`}>
          {message}
        </p> 
      </div>
      {message === 'Sequence incorrect. Try again.' && (
        <button 
          onClick={handleRetry} 
          className="mt-2 px-4 py-2 bg-blue-500 text-white rounded"
        >
          Retry
        </button>
      )}
    </div>
  );
};

export default Think5WhysIAmHuman;
